import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ASSETS, CONTACT, whatsappLink } from "../lib/constants";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer data-testid="site-footer" className="border-t-2 border-brand-orange bg-brand-black">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-3">
              <img src={ASSETS.logo} alt="logo" className="h-14 w-auto" />
              <div className="leading-none">
                <div className="font-display text-2xl">CASCANTE</div>
                <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-brand-orange">
                  Moto Rental
                </div>
              </div>
            </Link>
            <p className="mt-4 text-sm text-white/70">{t("tagline")}</p>
          </div>

          <div>
            <h4 className="mb-3 font-display text-xl uppercase">{t("nav.contact")}</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-brand-orange" />
                <a data-testid="footer-whatsapp" href={whatsappLink()} className="hover:text-brand-orange">
                  {CONTACT.whatsappDisplay}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-brand-orange" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-brand-orange break-all">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-brand-orange" />
                <span>{CONTACT.city}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 font-display text-xl uppercase">Menu</h4>
            <ul className="grid grid-cols-2 gap-2 text-sm">
              {[
                ["/", t("nav.home")],
                ["/rentals", t("nav.rentals")],
                ["/gallery", t("nav.gallery", "Gallery")],
                ["/about", t("nav.about")],
                ["/mission", t("nav.mission")],
                ["/find-us", t("nav.findus")],
                ["/contact", t("nav.contact")],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-brand-orange">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 font-display text-xl uppercase">Social</h4>
            <div className="flex gap-3">
              <a
                data-testid="footer-instagram"
                href={CONTACT.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center border border-white/20 hover:bg-brand-orange hover:text-white"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                data-testid="footer-facebook"
                href={CONTACT.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center border border-white/20 hover:bg-brand-orange hover:text-white"
              >
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-2 border-t border-white/10 pt-6 text-xs uppercase tracking-widest text-white/60">
          <span>© {new Date().getFullYear()} Cascante Moto Rental. {t("footer.rights")}</span>
          <span>
            Website created by{" "}
            <span className="text-white">Greg Miceli — Mr Positivity</span>.{" "}
            <a
              data-testid="footer-greg-contact"
              href="https://sqawk.app/profile/MrPositivity"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-orange underline-offset-2 hover:underline"
            >
              Contact Me
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
